// ── HomeClaudePanel (Evo Brain — Fase 3, briefing) ───────────────────────────
// Ya no renderiza UI propia — el shell genérico vive en AssistantDock, montado
// una vez en AppShell (ver contexts/AssistantContext.tsx). Esto solo registra
// "la entidad activa es 'home'" y conserva el único comportamiento propio de
// este módulo: el briefing automático al abrir el Home, una vez por sesión de
// browser (sessionStorage) — pedirlo a mano después siempre funciona.

import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';

const AUTO_BRIEFING_SESSION_KEY = 'evo-home-briefing-fired';
const AUTO_BRIEFING_PROMPT = '¿Qué tenemos para hoy?';

export function HomeClaudePanel() {
  const { t } = useTranslation();

  const assistant = useAssistantModule('home', null, undefined);
  useRegisterAssistantActive('home', null, {
    title: t('home.assistant.title'),
    placeholder: t('home.assistant.placeholder'),
    emptyHint: t('home.assistant.empty'),
  });

  const autoFiredRef = useRef(false);
  const isStreaming = assistant.streaming.phase !== 'idle';

  useEffect(() => {
    if (autoFiredRef.current) return;
    if (isStreaming) return;
    try {
      if (sessionStorage.getItem(AUTO_BRIEFING_SESSION_KEY)) { autoFiredRef.current = true; return; }
      sessionStorage.setItem(AUTO_BRIEFING_SESSION_KEY, '1');
    } catch {
      // sessionStorage no disponible (modo privado, etc.) — no autodisparar, pedirlo a mano sigue andando.
      autoFiredRef.current = true;
      return;
    }
    autoFiredRef.current = true;
    void assistant.sendMessage(AUTO_BRIEFING_PROMPT);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- disparo único al montar, no re-ejecutar por cambios de assistant/isStreaming
  }, []);

  return null;
}
